// extracted by mini-css-extract-plugin
export var deleteModal = "_hf-0";